export {
  getBoundsFromTargetWindow,
  getMaxHeight,
  getOppositeEdge,
  positionCallout,
  positionCard,
  positionElement,
} from './positioning';
export * from './positioning.types';
export type { IElementPosition, IElementPositionInfo } from './positioning';
